module.exports = __webpack_public_path__ + "static/media/restaurant (2).404973d1.jpg";